<template>
    <section class="sec sec-04 mt-5 mb-5 sec-padding">
        <div class="container-fluid">
            <div class="row justify-content-center">
                 <div class="col-lg-5">
                     <img class="screens-img wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".5s" src="/theme/img/screens.png">
                 </div>
                 <div class="col-lg-4">
                       <div class="sec-title text-left">
                           <h1 class=" wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" v-html="title"></h1>
                           <p class="screens-text wow fadeInUp" data-wow-duration="1s" data-wow-delay=".7s">
                               We are bringing in some of the most awaited features you ever wanted in an algorithmic trading platform to reality.<br>
                                <span class="spacer"></span>
                               <b> Marketplace:</b> A collection of fully automated highly optimized strategy series and verified SEBI ( Securities and Exchange Board of India) advisory packages from which you can subscribe to different algorithms and advisors.<br>
                                <span class="spacer"></span>
                                <b>Portfolio Watch:</b> A working dashboard where you can control and automate different trades. You can pause and stop the strategies you have subscribed to and also see the real-time progression of that trade.<br>
                                <span class="spacer"></span>
                                <b> Trade Log:</b> Keeping track of multiple trades and its outcome can be a tedious job. Trade log views all your past and ongoing trades in a well-defined and easy fashion. 
                           </p>
                        </div>
                 </div>
            </div>
        </div>
    </section>
</template>

<script>
import ScrollMagic from "scrollmagic";
import helpers from '@/plugins/helpers' 

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    titleSub:{
      type: String,
      default: ""
    }
  },
    mounted() {
     this.onscrollHandler()
   },
  methods: {
    onscrollHandler() {
      var controller = new ScrollMagic.Controller();
      var scene = new ScrollMagic.Scene({
        triggerElement: ".sec-04",
        offset: window.innerHeight * 0.3,
        duration: helpers.isMobile()?"10%":"30%",
      }).setPin(".sec-04");
       scene.on("enter progress", function (e) {
        })
      controller.addScene([scene]);
    }
  }
};
</script>